import { CURRENCY } from "../loads/common";

/** Human readable message from a Django/matching error. */
export const errText = (e, fallback) => {
  const d = e?.response?.data;
  if (d?.detail) return String(d.detail);
  if (d && typeof d === "object") {
    const first = Object.entries(d)[0];
    if (first) return `${first[0]}: ${Array.isArray(first[1]) ? first[1][0] : JSON.stringify(first[1])}`;
  }
  return e?.data?.error || (e?.message && !e?.response ? e.message : "") || fallback;
};

const CURRENCY_ID = Object.fromEntries(Object.entries(CURRENCY).map(([id, code]) => [code, Number(id)]));
/** 'KGS' -> 4 (the matching API sends currency codes, Django stores ids) */
export const currencyId = (code) => CURRENCY_ID[code] || null;
